<template>
  <div id="employees" class="col-12 p-0">
    <div class="row">
      <div>
        <!-- CREAR -->

        <!-- 1 MODAL CREACIÓN EMPLEADO -->

        <b-modal id="modal-create-em" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <h2 class="text-uppercase font-weight-bold">agregar Empleado</h2>
            <input
              v-model="nameLN"
              type="text"
              class="form-control mt-5 input-vp2"
              placeholder="Nombre Completo"
            />
            <b-form-select
              class="mt-3"
              v-model="selectedDT"
              :options="optionsDT"
            ></b-form-select>
            <input
              v-model="numberDT"
              type="number"
              class="form-control mt-3 input-vp2"
              placeholder="# de Documento"
            />
            <input
              v-model="email"
              type="mail"
              class="form-control mt-3 input-vp2"
              placeholder="Correo electrónico"
            />
            <b-form-select
              class="mt-3"
              v-model="selectedCT"
              :options="optionsCT"
            ></b-form-select>
            <input
              v-if="selectedCT.name == 'Directo'"
              v-model="numberSH"
              type="number"
              class="form-control mt-3 input-vp2"
              placeholder="Sharp ID"
            />
            <b-form-select
              class="mt-3"
              v-model="selectedCA"
              :options="optionsCA"
              @change="getChargesOrZones"
            ></b-form-select>
            <b-form-select
              v-if="zonesCheck"
              class="mt-3"
              v-model="selectedZ"
              :options="optionsZ"
              @change="getPointsSalesbyZone"
            ></b-form-select>
            <b-form-select
              v-if="selectedCA.id == 2 || selectedCA.id == 4"
              class="mt-3"
              v-model="selectedCH"
              :options="optionsCH"
            ></b-form-select>
            <b-form-select
              v-if="pointsSalesCheck"
              class="mt-3"
              v-model="selectedPS"
              :options="optionsPS"
              @change="getChargesbyPointsSales"
            ></b-form-select>
            <b-form-select
              v-if="pointsSalesCheck"
              class="mt-3"
              v-model="selectedCH"
              :options="optionsCH"
            ></b-form-select>
            <b-form-select
              v-if="selectedCH.rol_id == 13"
              class="mt-3"
              v-model="selectedLD"
              :options="optionsLD"
            ></b-form-select>
            <p v-if="error_message" class="alert alert-danger mt-3 mb-3">
              {{ error.message }}
            </p>
            <div v-if="loading" class="loaderSmall"></div>

            <div style="display: flex" class="mt-4">
              <button
                v-if="!loading"
                :disabled="
                  nameLN === '' ||
                  email === '' ||
                  selectedDT.id == null ||
                  numberDT == '' ||
                  selectedCT.id == null ||
                  (selectedCT.name == 'Directo' ? numberSH == '' : false) ||
                  selectedCA.name === 'default' ||
                  (zonesCheck ? selectedZ.id == null : false) ||
                  (pointsSalesCheck ? selectedPS.id == null : false) ||
                  (chargesCheck ? selectedCH.id == null : false) ||
                  error_message
                "
                @click="nextStep1CH('next')"
                type="button"
                class="button-primary enviar-mensaje mr-4 pt-1 pb-1"
                style="border: none"
              >
                <span class="cta">Siguiente</span>
              </button>
              <button
                type="button"
                class="button-secundary ml-4"
                style="margin: auto"
                @click="$bvModal.hide('modal-create-em')"
              >
                <span class="cta">Cancelar</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 1 MODAL CREACIÓN EMPLEADO 2 - INFORMACIÓN BANCARIA -->

        <b-modal id="modal-create2-em" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <h2 class="text-uppercase font-weight-bold">
              información Bancaria
            </h2>
            <v-select
              class="mt-3 col-12 p-0"
              label="name"
              v-model="selectedBK"
              :options="lists.banks"
            />
            <b-form-select
              class="mt-3"
              v-model="selectedAT"
              :options="optionsAT"
            ></b-form-select>
            <input
              v-model="numberBA"
              type="number"
              class="form-control mt-3 mb-4 input-vp2"
              placeholder="# de Cuenta"
            />
            <div v-if="loading" class="loaderSmall"></div>

            <div style="display: flex" class="mt-4">
              <button
                v-if="!loading"
                :disabled="
                  selectedBK == null ||
                  selectedAT.name == null ||
                  numberBA == ''
                "
                @click="nextStep1CH('next2')"
                type="button"
                class="button-primary enviar-mensaje mr-4 pt-1 pb-1"
                style="border: none"
              >
                <span class="cta">Guardar empleado</span>
              </button>
              <button
                type="button"
                class="button-secundary ml-4"
                style="margin: auto"
                @click="nextStep1CH('previous')"
              >
                <span class="cta">Cancelar</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 2 MODAL CREACIÓN EMPLEADO -->

        <b-modal
          v-if="selectedCA.name !== null"
          id="modal-create3-em"
          hide-footer
          centered
        >
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/warning_.svg"
              width="15%"
            />
            <h3 class="pt-5 mb-5 font-weight-bold">
              ¿Estás seguro de guardar este Empleado?
            </h3>
            <p v-if="selectedCH.training" class="mb-5">
              <span class="text-uppercase" style="color: #ff6700"
                >Empleado en entrenamiento</span
              >
            </p>
            <p class="pt-2">
              <span class="text-uppercase font-weight-bold">Nombre: </span>
              {{ nameLN }}
            </p>
            <p style="font-size: 16px">
              <span class="font-weight-bold">{{ selectedDT.name }}: </span
              >{{ numberDT }}
            </p>
            <p style="font-size: 16px">
              <span class="font-weight-bold">Correo: </span>{{ email }}
            </p>
            <p style="font-size: 16px">
              <span class="font-weight-bold">Tipo de Contrato: </span
              >{{ selectedCT.name }}
            </p>
            <p v-if="numberSH !== ''" style="font-size: 16px">
              <span class="font-weight-bold">Sharp ID: </span>{{ numberSH }}
            </p>
            <p style="font-size: 16px">
              <span class="font-weight-bold">Categoria: </span
              >{{ selectedCA.name }}
            </p>
            <p v-if="zonesCheck" style="font-size: 16px">
              <span class="font-weight-bold">Zona: </span>{{ selectedZ.name }}
            </p>
            <p v-if="pointsSalesCheck" style="font-size: 16px">
              <span class="font-weight-bold">Punto de Venta: </span
              >{{ selectedPS.name }}
            </p>
            <p v-if="chargesCheck" style="font-size: 16px">
              <span class="font-weight-bold">Cargo: </span>{{ selectedCH.name }}
            </p>
            <hr />
            <h3 class="pt-2 mb-5 font-weight-bold">Información bancaría</h3>
            <p v-if="selectedBK" style="font-size: 16px">
              <span class="font-weight-bold">Banco: </span>{{ selectedBK.name }}
            </p>
            <p style="font-size: 16px">
              <span class="font-weight-bold"
                >{{
                  selectedAT.name == "Ahorros"
                    ? "Cuenta de ahorros:"
                    : "Cuenta Corriente:"
                }} </span
              >{{ numberBA }}
            </p>
            <div style="display: flex" class="pt-2 mt-4">
              <button
                type="button"
                class="button-secundary mr-4"
                style="margin: auto"
                @click="nextStep1CH('previous2')"
              >
                <span class="cta" style="width: 100%">Seguir editando</span>
              </button>
              <button
                @click="nextStep1CH('save')"
                type="button"
                class="button-primary enviar-mensaje ml-4"
                style="border: none"
              >
                <span class="cta" style="width: 100%">Guardar Empleado</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 3 MODAL CREACIÓN LINEA DE NEGOCIO -- EXITOSO  -->

        <b-modal id="modal-success" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/checkbox-circle-line.svg"
            />
            <h3 class="pt-5 font-weight-bold">¡Proceso exitoso!</h3>
            <p class="pt-2">{{ message.message }}</p>
            <button
              @click="$bvModal.hide('modal-success')"
              type="button"
              class="button-primary enviar-mensaje"
              style="border: none"
            >
              <span class="cta" style="width: 100%">Entendido</span>
            </button>
          </div>
        </b-modal>

        <!-- 3 MODAL FALLO DE OPERACIÓN -- FALLIDO -->

        <b-modal v-if="error.message" id="modal-fail" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/close.svg"
              width="20%"
            />
            <h3 class="pt-5 font-weight-bold">¡Proceso fallido!</h3>
            <p class="pt-5">{{ error.message }}</p>
            <button
              class="mt-5 mb-5 col-6 btn btn-danger"
              @click="$bvModal.hide('modal-fail')"
            >
              Entendido
            </button>
          </div>
        </b-modal>

        <!-- EDITAR/ELIMINAR -->

        <!-- 1 MODAL EDICIÓN LINEA DE NEGOCIO -->

        <b-modal id="modal-edit-em" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <h2 class="text-uppercase font-weight-bold">Editar Empleado</h2>
            <input
              v-model="nameLN"
              type="text"
              class="form-control mt-5 input-vp2"
              placeholder="Nombre Completo"
            />
            <b-form-select
              class="mt-3"
              v-model="selectedDT"
              :options="optionsDT"
            ></b-form-select>
            <input
              v-model="numberDT"
              type="number"
              class="form-control mt-3 input-vp2"
              placeholder="# de Documento"
            />
            <input
              v-model="email"
              type="mail"
              class="form-control mt-3 input-vp2"
              placeholder="Correo electrónico"
            />
            <b-form-select
              class="mt-3"
              v-model="selectedCT"
              :options="optionsCT"
            ></b-form-select>
            <input
              v-if="selectedCT.name == 'Directo'"
              v-model="numberSH"
              type="number"
              class="form-control mt-3 input-vp2"
              placeholder="Sharp ID"
            />
            <b-form-select
              class="mt-3"
              v-model="selectedCA"
              :options="optionsCA"
              @change="getChargesOrZones"
            ></b-form-select>
            <b-form-select
              v-if="zonesCheck"
              class="mt-3"
              v-model="selectedZ"
              :options="optionsZ"
              @change="getPointsSalesbyZone"
            ></b-form-select>
            <b-form-select
              v-if="pointsSalesCheck"
              class="mt-3"
              v-model="selectedPS"
              :options="optionsPS"
              @change="getChargesbyPointsSales"
            ></b-form-select>
            <b-form-select
              v-if="chargesCheck"
              class="mt-3"
              v-model="selectedCH"
              :options="optionsCH"
            ></b-form-select>
            <p v-if="error_message" class="alert alert-danger mt-3">
              {{ error.message }}
            </p>
            <div v-if="loading" class="loaderSmall"></div>

            <div style="display: flex" class="mt-4">
              <button
                v-if="!loading"
                :disabled="
                  nameLN === '' ||
                  email === '' ||
                  selectedDT.id == null ||
                  numberDT == '' ||
                  selectedCT.id == null ||
                  (selectedCT.name == 'Directo' ? numberSH == '' : false) ||
                  selectedCA.name === 'default' ||
                  (zonesCheck ? selectedZ.id == null : false) ||
                  (pointsSalesCheck ? selectedPS.id == null : false) ||
                  (chargesCheck ? selectedCH.id == null : false) ||
                  error_message
                "
                @click="nextStep2CH('next')"
                type="button"
                class="button-primary enviar-mensaje mr-4"
                style="border: none"
              >
                <span class="cta">Siguiente</span>
              </button>
              <button
                class="delete button-primary enviar-mensaje ml-4"
                type="button"
                @click="nextStep2CH('nextD')"
              >
                <img src="@/assets/images/icons/delete_trash_white.svg" />
                <span class="cta ml-2"> Borrar Empleado</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!--  2 MODAL EDICIÓN LINEA DE NEGOCIO -->

        <b-modal id="modal-edit2-em" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <h2 class="text-uppercase font-weight-bold">
              Editar información Bancaria
            </h2>
            <v-select
              class="mt-3 col-12 p-0"
              label="name"
              v-model="selectedBK"
              :options="lists.banks"
            />
            <b-form-select
              class="mt-3"
              v-model="selectedAT"
              :options="optionsAT"
            ></b-form-select>
            <input
              v-model="numberBA"
              type="number"
              class="form-control mt-3 mb-4 input-vp2"
              placeholder="# de Cuenta"
            />
            <div v-if="loading" class="loaderSmall"></div>

            <div style="display: flex" class="mt-4">
              <button
                v-if="!loading"
                :disabled="
                  selectedBK == null ||
                  selectedAT.name == null ||
                  numberBA == ''
                "
                @click="nextStep2CH('next2')"
                type="button"
                class="button-primary enviar-mensaje mr-4 pt-1 pb-1"
                style="border: none"
              >
                <span class="cta">Guardar Cambios</span>
              </button>
              <button
                type="button"
                class="button-secundary ml-4"
                style="margin: auto"
                @click="nextStep2CH('previous')"
              >
                <span class="cta">Regresar</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 3 MODAL EDICIÓN LINEA DE NEGOCIO -->

        <b-modal id="modal-edit3-em" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/warning_.svg"
              width="15%"
            />
            <h3 class="pt-5 font-weight-bold">
              ¿Estás seguro de modificar este Empleado?
            </h3>
            <p class="pt-5">
              <b>Nombre:</b>
              {{ nameLN }}
            </p>
            <p v-if="selectedCH.training" class="mb-5">
              <span class="text-uppercase" style="color: #ff6700"
                >Empleado en entrenamiento</span
              >
            </p>
            <p style="font-size: 16px">
              <span class="font-weight-bold">{{ selectedDT.name }}: </span
              >{{ numberDT }}
            </p>
            <p style="font-size: 16px">
              <span class="font-weight-bold">Tipo de Contrato: </span
              >{{ selectedCT.name }}
            </p>
            <p style="font-size: 16px">
              <span class="font-weight-bold">Correo: </span>{{ email }}
            </p>
            <p v-if="numberSH !== ''" style="font-size: 16px">
              <span class="font-weight-bold">Sharp ID: </span>{{ numberSH }}
            </p>
            <p style="font-size: 16px">
              <span class="font-weight-bold">Categoria: </span
              >{{ selectedCA.name }}
            </p>
            <p v-if="zonesCheck" style="font-size: 16px">
              <span class="font-weight-bold">Zona: </span>{{ selectedZ.name }}
            </p>
            <p v-if="pointsSalesCheck" style="font-size: 16px">
              <span class="font-weight-bold">Punto de Venta: </span
              >{{ selectedPS.name }}
            </p>
            <p v-if="chargesCheck" style="font-size: 16px">
              <span class="font-weight-bold">Cargo: </span>{{ selectedCH.name }}
            </p>
            <p v-if="selectedBK" style="font-size: 16px">
              <span class="font-weight-bold">Banco: </span>{{ selectedBK.name }}
            </p>
            <p style="font-size: 16px">
              <span class="font-weight-bold"
                >{{
                  selectedAT.name == "Ahorros"
                    ? "Cuenta de ahorros:"
                    : "Cuenta Corriente:"
                }} </span
              >{{ numberBA }}
            </p>
            <div style="width: 100%; display: flex; margin-top: 32px">
              <button
                type="button"
                class="button-secundary"
                style="margin: auto"
                @click="nextStep2CH('previous2')"
              >
                <span class="cta" style="width: 100%">Seguir editando</span>
              </button>
              <button
                @click="nextStep2CH('edit')"
                type="button"
                class="button-primary enviar-mensaje"
                style="border: none"
              >
                <span class="cta" style="width: 100%">Guardar cambios</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 4 MODAL ELIMINAR LINEA DE NEGOCIO -->

        <b-modal id="modal-delete-em" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1 mb-4"
              src="@/assets/images/icons/warning_.svg"
              width="15%"
            />
            <h3 class="pt-2 font-weight-bold">
              ¿Estás seguro de eliminar el Empleado?
            </h3>
            <p class="pt-2 text-danger">
              Al confirmar no podrás recuperar los cambios.
            </p>
            <p class="pt-2">
              <span class="text-uppercase">{{ nameLN }}</span>
            </p>
            <div style="display: flex" class="mt-2">
              <button
                type="button"
                class="button-secundary mr-4"
                style="margin: auto"
                @click="nextStep2CH('previous')"
              >
                <span class="cta">No borrar</span>
              </button>
              <button
                class="delete button-primary enviar-mensaje ml-4"
                type="button"
                @click="nextStep2CH('delete')"
              >
                <img
                  src="@/assets/images/icons/delete_trash_white.svg"
                  alt=""
                />
                <span class="cta ml-2"> Borrar Empleado</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 4 MODAL CARGAR ARCHIVO -->

        <b-modal id="modal-upload" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center modal-vp2">
            <div v-if="loading2" class="col-12">
              <div v-if="loading2" id="loader2"></div>
            </div>
            <div v-else class="file-upload-img col-12">
              <input
                type="file"
                id="fileDocu"
                @change="fileSelected"
                accept=".xlsx"
                required
              />
              <span v-if="!nameFile">
                <img
                  class="col-12"
                  src="@/assets/images/settler/uploadFile.jpg"
                />
              </span>
              <span
                v-else
                class="col-12"
                style="display: table; margin: 0 auto"
              >
                <p class="p3">
                  <b>{{ nameFile }}</b>
                </p>
              </span>
            </div>
            <button
              :disabled="nameFile == ''"
              class="mt-2 mb-2 col-6 btn btn-success"
              @click="saveFileSelected()"
            >
              Subir Archivo
            </button>
            <button class="regular mb-3" @click="$bvModal.hide('modal-upload')">
              Cancelar
            </button>
          </div>
        </b-modal>
      </div>
    </div>
    <div class="row">
      <SelectSettings />
      <!-- Boton Crear Empleado -->
      <div class="col-lg-3 col-sm-3 mt-4">
        <b-dropdown class="btn-create" right text="Agregar Empleado">
          <b-dropdown-item @click="create()">
            <span style="font-size: 15px" class="icon icon icon-plus mt-1 mr-1">
            </span>
            Crear nuevo empleado</b-dropdown-item
          >
          <b-dropdown-item
            @click="$bvModal.show('modal-upload'), (nameFile = '')"
          >
            <span
              style="font-size: 15px"
              class="icon icon icon-upload3 mt-1 mr-1"
            >
            </span>
            Cargar masiva de empleados</b-dropdown-item
          >
          <b-dropdown-item
            :href="serverPath + '/storage/docs/EmpleadosPropinas.xlsx'"
            target="_blank"
          >
            <span
              style="font-size: 15px"
              class="icon icon icon-download3 mt-1 mr-1"
            >
            </span>
            Descargar formato de carga masiva</b-dropdown-item
          >
        </b-dropdown>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <div class="mb-12 card-personalizada">
          <div class="card-header card-header-left">
            <h3 style="color:color: #263238;">Lista de Empleados</h3>
          </div>
          <div class="col-12">
            <div class="buscar-empleado mt-4 mb-4">
              <div class="input-group-prepend">
                <span class="icon icon-search1"></span>
              </div>
              <input
                type="search"
                placeholder="Buscar Empleado"
                aria-label="Buscar Empleado"
                autocomplete="off"
                class="form-control body_regular"
                v-model="filter"
                style="border: 0px"
                @keydown="startTipyng()"
                @keyup="finishTipyng()"
              />
            </div>
          </div>
          <div class="mt-5" v-if="loading" id="loader"></div>
          <div v-else class="col-12 ml-1 mt-2 mb-1 mr-2">
            <datatable
              :columns="datatable.columns"
              :data="datatable.rows"
              :filter="datatable.filter"
              :per-page="datatable.perPage"
              :page="datatable.page"
              class="col-12 mt-5 table table-hover table-borderless"
            >
              <template slot-scope="{ row, columns }">
                <tr @click="editEmployee(row)">
                  <template>
                    <datatable-cell
                      v-for="(column, j) in columns"
                      :key="j"
                      :column="column"
                      :row="row"
                    >
                    </datatable-cell>
                  </template>
                </tr>
              </template>
            </datatable>
            <div
              class="col-12 cont-pagination my-5 d-flex justify-content-center"
            >
              <Pagination
                :data="employees.data"
                :limit="10"
                @pagination-change-page="getEmployees"
              >
                <template #prev-nav>
                  <span>&lt;</span>
                </template>
                <template #next-nav>
                  <span>&gt;</span>
                </template>
              </Pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Pagination from "laravel-vue-pagination";
import SelectSettings from "@/components/platformSettings/selectSettings.vue";
import serverConfig from "./../../../services/config";
export default {
  name: "LineBusiness",
  components: { Pagination, SelectSettings },
  data() {
    return {
      nameFile: "",
      serverPath: serverConfig.permisosURL,
      selectedCA: { name: "default", id: null, categoria_padre_id: 0 },
      optionsCA: [
        {
          value: { name: "default", id: null, categoria_padre_id: 0 },
          text: "Asigna una categoria",
        },
      ],
      selectedDT: { id: null, name: null },
      optionsDT: [
        { value: { id: null, name: null }, text: "Tipo de documento" },
      ],
      selectedCT: { id: null, name: null },
      optionsCT: [
        { value: { id: null, name: null }, text: "Tipo de contrato" },
      ],
      selectedAT: { id: null, name: null },
      optionsAT: [{ value: { id: null, name: null }, text: "Tipo de cuenta" }],
      selectedZ: { name: "default", id: null },
      optionsZ: [
        { value: { name: "default", id: null }, text: "Asigna una Zona" },
      ],
      selectedPS: { name: "default", id: null },
      optionsPS: [
        {
          value: { name: "default", id: null },
          text: "Asigna un Punto de Venta",
        },
      ],
      selectedCH: { name: "default", id: null, rol_id: null, training: null },
      optionsCH: [
        {
          value: { name: "default", id: null, rol_id: null, training: null },
          text: "Asigna un Cargo",
        },
      ],
      selectedBK: { name: "Selecciona un Banco" },
      selectedLD: { id: null, name: null },
      optionsLD: [
        {
          value: { id: null, name: null },
          text: "Selecciona una linea de Negocio",
        },
      ],
      pointsSalesCheck: false,
      zonesCheck: false,
      chargesCheck: false,
      error_message: false,
      indexRow: 0,
      nameLN: "",
      email: "",
      numberDT: "",
      numberSH: "",
      numberBA: "",
      modalCreateNew: "",
      filter: "",
      datatable: {
        total: 18,
        perPage: 10,
        last_page: 2,
        page: 1,
        columns: [],
        rows: [],
      },
      runTime: "",
    };
  },
  beforeMount() {
    this.getLists();
    this.getCategorys();
    this.getEmployees();
  },
  computed: {
    ...mapState("modPlatformSettings", [
      "employees",
      "employee",
      "pointsSales",
      "lists",
      "charges",
      "zones",
      "services",
      "loading",
      "loading2",
      "error",
      "message",
    ]),

    checkEdit: function () {
      return this.nameLN === "";
    },
  },
  methods: {
    ...mapActions("modPlatformSettings", [
      "actGetEmployees",
      "actGetEmployee",
      "actGetLists",
      "actEmployee",
      "actGetCustomList",
      "actPointsSalesByZone",
      "actServices",
      "actChargesByPointSales",
      "actSaveEmployee",
      "actActEmployee",
      "actDelEmployee",
      "actGetZonesByLB",
      "actGenerateExcelWorkers",
      "actSaveFileEmployee",
    ]),

    startTipyng() {
      clearTimeout(this.runTime);
    },
    finishTipyng() {
      this.runTime = setTimeout(() => {
        this.getEmployees();
      }, 1500);
    },
    resetValues() {
      (this.selectedCA = { name: "default", id: null, categoria_padre_id: 0 }),
        (this.selectedDT = { id: null, name: null });
      this.selectedCT = { id: null, name: null };
      this.selectedAT = { id: null, name: null };
      this.selectedZ = { name: "default", id: null };
      this.selectedPS = { name: "default", id: null };
      this.selectedCH = {
        name: "default",
        id: null,
        rol_id: null,
        training: null,
      };
      this.selectedBK = { name: "Selecciona un Banco" };
      this.pointsSalesCheck = false;
      this.zonesCheck = false;
      this.chargesCheck = false;
      this.error_message = false;
      this.indexRow = 0;
      this.nameLN = "";
      this.email = "";
      this.numberDT = "";
      this.numberSH = "";
      this.numberBA = "";
      this.modalCreateNew = "";
    },

    create() {
      this.resetValues();
      this.$root.$emit("bv::show::modal", "modal-create-em");
    },

    nextStep1CH(x) {
      let data = {
        name: this.nameLN,
        email: this.email,
        document_type_id: this.selectedDT.id,
        cc: this.numberDT,
        type_contract_id: this.selectedCT.id,
        sharp_id: this.numberSH !== "" ? this.numberSH : null,
        category_type: this.selectedCA.categoria_padre_id == 1 ? "ld" : "sb",
        pro_category_type_id: this.selectedCA.id,
        pro_zone_id: this.selectedZ.id,
        pro_point_sale_id: this.selectedPS.id,
        bank_id: this.selectedBK.id,
        account_type_id: this.selectedAT.id,
        account_number: this.numberBA,
        position_id: this.selectedCH.id,
      };
      switch (x) {
        case "next":
          this.$root.$emit("bv::hide::modal", "modal-create-em");
          this.$root.$emit("bv::show::modal", "modal-create2-em");
          break;
        case "next2":
          this.$root.$emit("bv::hide::modal", "modal-create2-em");
          this.$root.$emit("bv::show::modal", "modal-create3-em");
          break;
        case "previous":
          this.$root.$emit("bv::hide::modal", "modal-create2-em");
          this.$root.$emit("bv::show::modal", "modal-create-em");
          break;
        case "previous2":
          this.$root.$emit("bv::hide::modal", "modal-create3-em");
          this.$root.$emit("bv::show::modal", "modal-create2-em");
          break;
        case "save":
          this.actSaveEmployee(data).then(() => {
            if (this.error.message) {
              this.$root.$emit("bv::hide::modal", "modal-create3-em");
              this.$root.$emit("bv::show::modal", "modal-fail");
              this.getEmployees();
              this.resetValues();
            } else {
              this.$root.$emit("bv::hide::modal", "modal-create3-em");
              this.$root.$emit("bv::show::modal", "modal-success");
              this.getEmployees();
              this.resetValues();
            }
          });
          break;
        default:
      }
    },
    loadRows() {
      this.optionsCA = [
        {
          value: { name: "default", id: null, categoria_padre_id: 0 },
          text: "Asigna una categoria",
        },
      ];
      this.actServices().then(() => {
        let line_deals = [];
        let support_bags = [];
        this.services.line_deal.forEach((x) => {
          line_deals.push({
            value: {
              id: x.id,
              name: x.name,
              categoria_padre_id: 1,
            },
            text: x.name,
          });
        });
        this.services.support_bag.forEach((x) => {
          support_bags.push({
            value: {
              id: x.id,
              name: x.name,
              categoria_padre_id: 2,
            },
            text: x.name,
          });
        });
        this.optionsCA.push(
          {
            label: "Lineas de Negocio",
            options: line_deals,
          },
          {
            label: "Bolsas de Apoyo",
            options: support_bags,
          }
        );
      });
      this.datatable = {
        total: 18,
        filter: "",
        perPage: 10,
        last_page: 2,
        page: 1,
        columns: [],
        rows: [],
      };
      this.datatable.columns = [
        {
          label: "Nombre",
          field: "name",
          align: "left",
          headerClass: "theading",
        },
        {
          label: "Documento",
          field: "document",
          align: "left",
          headerClass: "theading",
          interpolate: true,
        },
        {
          label: "Contrato",
          field: "contract",
          align: "left",
          headerClass: "theading",
        },
        {
          label: "Categoría",
          field: "category",
          align: "left",
          headerClass: "theading",
        },
        {
          label: "PDV",
          field: "point_sales",
          align: "left",
          headerClass: "theading",
        },
        {
          label: "Cargo",
          field: "charge",
          align: "left",
          headerClass: "theading",
        },
      ];
    },
    getEmployees(page = 1) {
      let data = {};
      data = {
        page: page,
        filter: this.filter,
      };

      this.actGetEmployees(data).then(() => {
        this.loadRows();
        this.employees.data.data.forEach((x) => {
          this.datatable.rows.push({
            id: x.id,
            name: x.name,
            document: x.document_number,
            contract: x.contract,
            category: x.category,
            point_sales: x.point_sale,
            charge: x.charge,
          });
        });
      });
    },
    getLists() {
      this.actGetLists().then(() => {
        this.optionsDT = [
          { value: { id: null, name: null }, text: "Tipo de documento" },
        ];
        this.optionsCT = [
          { value: { id: null, name: null }, text: "Tipo de contrato" },
        ];
        this.lists.documents_type.forEach((x) => {
          this.optionsDT.push({
            value: {
              id: x.id,
              name: x.name,
            },
            text: x.name,
          });
        });
        this.lists.types_contract.forEach((x) => {
          this.optionsCT.push({
            value: { id: x.id, name: x.name },
            text: x.name,
          });
        });
        this.lists.accounts_type.forEach((x) => {
          this.optionsAT.push({
            value: { id: x.id, name: x.name },
            text: x.name,
          });
        });
      });
    },
    getCategorys() {
      this.actServices(() => {
        this.employees.data.data.forEach((x) => {
          if (x.category_type == "ld") {
            this.services.line_deal.forEach((y) => {
              if (y.id == x.pro_category_id) {
                this.datatable.rows.push({
                  id: x.id,
                  name: x.name,
                  category: y.name,
                });
              }
            });
          } else if (x.category_type == "sb") {
            this.services.support_bag.forEach((y) => {
              if (y.id == x.pro_category_id) {
                this.datatable.rows.push({
                  id: x.id,
                  name: x.name,
                  category: y.name,
                });
              }
            });
          }
        });
      });
    },

    // Evalua si la linea de negocio tiene o no zonas, para asi mismo devolver Puntos de ventas o Zonas

    getChargesOrZones() {
      let data = {
        category_type: this.selectedCA.categoria_padre_id == 1 ? "ld" : "sb",
        pro_category_id: this.selectedCA.id,
      };
      this.actGetCustomList(data).then(() => {
        this.zonesCheck = false;
        this.pointsSalesCheck = false;
        this.chargesCheck = false;
        this.error_message = false;
        if (this.zones[0]) {
          this.selectedZ = { name: "default", id: null };
          this.optionsZ = [
            { value: { name: "default", id: null }, text: "Asigna una Zona" },
          ];
          this.zones.forEach((x) => {
            this.optionsZ.push({
              value: { name: x.name, id: x.id },
              text: x.name,
            });
          });
          this.zonesCheck = true;

          // Si el empleado se esta editando  -- Asigna el valor que trae desde el servico

          if (this.employee.pro_zone_id !== null) {
            this.optionsZ.forEach((x) => {
              if (x.value.id == this.employee.pro_zone_id) {
                this.selectedZ = x.value;
                this.getPointsSalesbyZone();
              }
            });
          }
        } else if (this.charges[0] && this.pointsSales[0]) {
          (this.selectedCH = {
            name: "default",
            id: null,
            rol_id: null,
            training: null,
          }),
            (this.optionsCH = [
              {
                value: {
                  name: "default",
                  id: null,
                  rol_id: null,
                  training: null,
                },
                text: "Asigna un Cargo",
              },
            ]);
          this.charges.forEach((x) => {
            this.optionsCH.push({
              value: {
                name: x.name,
                id: x.id,
                rol_id: x.core_role_id,
                training: x.training,
              },
              text: x.name,
            });
          });
          this.chargesCheck = true;

          // Si el empleado se esta editando  -- Asigna el valor que trae desde el servico

          if (this.employee.position_id) {
            this.optionsCH.forEach((x) => {
              if (x.value.id == this.employee.position_id) {
                this.selectedCH = x.value;
              }
            });
          }

          this.selectedPS = { name: "default", id: null };
          this.optionsPS = [
            {
              value: { name: "default", id: null },
              text: "Asigna un Punto de Venta",
            },
          ];
          this.pointsSales.forEach((x) => {
            this.optionsPS.push({
              value: { name: x.name, id: x.id },
              text: x.name,
            });
          });
          this.pointsSalesCheck = true;

          // Si el empleado se esta editando  -- Asigna el valor que trae desde el servico

          if (this.employee.pro_point_sale_id) {
            this.optionsPS.forEach((x) => {
              if (x.value.id == this.employee.pro_point_sale_id) {
                this.selectedPS = x.value;
              }
            });
          }
        } else if (this.charges[0] || this.pointsSales[0]) {
          (this.selectedCH = {
            name: "default",
            id: null,
            rol_id: null,
            training: null,
          }),
            (this.optionsCH = [
              {
                value: {
                  name: "default",
                  id: null,
                  rol_id: null,
                  training: null,
                },
                text: "Asigna un Cargo",
              },
            ]);
          this.charges.forEach((x) => {
            this.optionsCH.push({
              value: {
                name: x.name,
                id: x.id,
                rol_id: x.core_role_id,
                training: x.training,
              },
              text: x.name,
            });
          });
          this.chargesCheck = true;

          // Si el empleado se esta editando  -- Asigna el valor que trae desde el servico

          if (this.employee.position_id) {
            this.optionsCH.forEach((x) => {
              if (x.value.id == this.employee.position_id) {
                this.selectedCH = x.value;
              }
            });
          }
        }
      });
    },
    getPointsSalesbyZone() {
      this.actPointsSalesByZone(this.selectedZ.id).then(() => {
        this.chargesCheck = false;
        this.pointsSalesCheck = false;
        this.error_message = false;
        if (this.pointsSales.data) {
          this.selectedPS = { name: "default", id: null };
          this.optionsPS = [
            {
              value: { name: "default", id: null },
              text: "Asigna un Punto de Venta",
            },
          ];
          this.pointsSales.data.forEach((x) => {
            this.optionsPS.push({
              value: { name: x.name, id: x.id },
              text: x.name,
            });
          });
          this.pointsSalesCheck = true;

          // Si el empleado se esta editando  -- Asigna el valor que trae desde el servico

          if (this.employee.pro_point_sale_id) {
            this.optionsPS.forEach((x) => {
              if (x.value.id == this.employee.pro_point_sale_id) {
                this.selectedPS = x.value;
                this.getChargesbyPointsSales();
              }
            });
          }
        }
      });
    },
    getChargesbyPointsSales() {
      if (this.zones[0]) {
        this.actChargesByPointSales(this.selectedPS.id).then(() => {
          this.chargesCheck = false;
          this.error_message = false;
          if (this.charges.data) {
            (this.selectedCH = {
              name: "default",
              id: null,
              rol_id: null,
              training: null,
            }),
              (this.optionsCH = [
                {
                  value: {
                    name: "default",
                    id: null,
                    rol_id: null,
                    training: null,
                  },
                  text: "Asigna un Cargo",
                },
              ]);
            this.charges.data.forEach((x) => {
              this.optionsCH.push({
                value: {
                  name: x.name,
                  id: x.id,
                  rol_id: x.core_role_id,
                  training: x.training,
                },
                text: x.name,
              });
            });
            this.chargesCheck = true;

            // Si el empleado se esta editando  -- Asigna el valor que trae desde el servico

            if (this.employee.position_id) {
              this.optionsCH.forEach((x) => {
                if (x.value.id == this.employee.position_id) {
                  this.selectedCH = x.value;
                }
              });
            }
          } else {
            this.error_message = true;
          }
        });
      }
    },
    editEmployee(row) {
      this.resetValues();
      this.actGetEmployee(row.id).then(() => {
        this.email = this.employee.email;
        this.nameLN = this.employee.name;
        this.numberDT = this.employee.cc;
        this.numberSH =
          this.employee.sharp_id == null ? "" : this.employee.sharp_id;
        this.numberBA = this.employee.account_number;
        if (this.employee.category_type == "ld") {
          this.optionsCA[1].options.forEach((x) => {
            if (x.value.id == this.employee.pro_category_type_id) {
              this.selectedCA = x.value;
              this.getChargesOrZones();
            }
          });
        } else {
          this.optionsCA[2].options.forEach((x) => {
            if (x.value.id == this.employee.pro_category_type_id) {
              this.selectedCA = x.value;
              this.getChargesOrZones();
            }
          });
        }

        this.optionsDT.forEach((x) => {
          if (x.value.id == this.employee.document_type_id) {
            this.selectedDT = x.value;
          }
        });

        this.optionsCT.forEach((x) => {
          if (x.value.id == this.employee.type_contract_id) {
            this.selectedCT = x.value;
          }
        });

        this.optionsAT.forEach((x) => {
          if (x.value.id == this.employee.account_type_id) {
            this.selectedAT = x.value;
          }
        });

        this.lists.banks.forEach((x) => {
          if (x.id == this.employee.bank_id) {
            this.selectedBK = x;
          }
        });
        this.$root.$emit("bv::show::modal", "modal-edit-em");
      });
    },
    nextStep2CH(x) {
      let data = {
        name: this.nameLN,
        email: this.email,
        document_type_id: this.selectedDT.id,
        cc: this.numberDT,
        type_contract_id: this.selectedCT.id,
        sharp_id: this.numberSH !== "" ? this.numberSH : null,
        category_type: this.selectedCA.categoria_padre_id == 1 ? "ld" : "sb",
        pro_category_type_id: this.selectedCA.id,
        pro_zone_id: this.selectedZ.id,
        pro_point_sale_id: this.selectedPS.id,
        bank_id: this.selectedBK.id,
        account_type_id: this.selectedAT.id,
        account_number: this.numberBA,
        position_id: this.selectedCH.id,
        id: this.employee.id,
      };
      switch (x) {
        case "next":
          this.$root.$emit("bv::hide::modal", "modal-edit-em");
          this.$root.$emit("bv::show::modal", "modal-edit2-em");
          break;
        case "next2":
          this.$root.$emit("bv::hide::modal", "modal-edit2-em");
          this.$root.$emit("bv::show::modal", "modal-edit3-em");
          break;
        case "previous":
          this.$root.$emit("bv::hide::modal", "modal-edit2-em");
          this.$root.$emit("bv::hide::modal", "modal-delete-em");
          this.$root.$emit("bv::show::modal", "modal-edit-em");
          break;
        case "previous2":
          this.$root.$emit("bv::hide::modal", "modal-edit3-em");
          this.$root.$emit("bv::show::modal", "modal-edit2-em");
          break;
        case "edit":
          this.actActEmployee(data).then(() => {
            if (this.error.message) {
              this.resetValues();
              this.$root.$emit("bv::hide::modal", "modal-edit3-em");
              this.$root.$emit("bv::show::modal", "modal-fail");
              this.getEmployees();
              return;
            } else {
              this.resetValues();
              this.$root.$emit("bv::hide::modal", "modal-edit3-em");
              this.$root.$emit("bv::show::modal", "modal-success");
              this.getEmployees();
            }
          });
          break;
        case "nextD":
          this.$root.$emit("bv::hide::modal", "modal-edit-em");
          this.$root.$emit("bv::show::modal", "modal-delete-em");
          break;
        case "delete":
          this.actDelEmployee(data.id).then(() => {
            if (this.error.message) {
              this.resetValues();
              this.$root.$emit("bv::hide::modal", "modal-delete-em");
              this.$root.$emit("bv::show::modal", "modal-fail");
              this.getEmployees();
            } else {
              this.resetValues();
              this.$root.$emit("bv::hide::modal", "modal-delete-em");
              this.$root.$emit("bv::show::modal", "modal-success");
              this.getEmployees();
            }
          });
          break;
        default:
      }
    },

    fileSelected() {
      const dato = document.querySelector("#fileDocu");
      this.nameFile = dato.files[0].name;
    },

    saveFileSelected() {
      var formData = new FormData();
      const fileSelected = document.querySelector("#fileDocu");
      formData.append("file", fileSelected.files[0]);
      this.actSaveFileEmployee(formData).then(() => {
        if (this.error.message) {
          this.resetValues();
          this.$root.$emit("bv::hide::modal", "modal-upload");
          this.$root.$emit("bv::show::modal", "modal-fail");
          this.getEmployees();
        } else {
          this.resetValues();
          this.$root.$emit("bv::hide::modal", "modal-upload");
          this.$root.$emit("bv::show::modal", "modal-success");
          this.getEmployees();
        }
      });
    },
  },
};
</script>
<style lang="scss">
#employees {
  .buscar-empleado {
    /* Auto layout */

    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 12px;

    position: relative;
    width: 428px !important;
    height: 44px;
    //left: 30px;
    top: calc(50% - 44px / 2);
    margin-bottom: 24px;

    background: #ffffff;
    /* content/03 */

    border: 1px solid #b0bec5;
    border-radius: 22px;

    /* Inside auto layout */

    flex: none;
    order: 0;
    flex-grow: 1;
    margin: 16px 0px;
  }
  .buscar-empleado .form-control {
    border: 0px !important;
    font-family: Ubuntu !important;
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 16px !important;
    line-height: 28px !important;
  }

  .card-header-left {
    /* Neutral / Gray blue light */
    background: #f5f5f5;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    border-bottom: none;

    widows: 100%;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }

  .card-header-text {
    /* Header Tablas */

    font-style: normal;
    //background: #F5F5F5;
    font-size: 16px;
    /* identical to box height */
    /* Alert/Succes */
    color: #263238 !important;
    width: 100%;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }
  .card-personalizada {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    position: static;
    background: #ffffff;
    border: 0px solid #eceff1 !important;
    box-sizing: border-box;
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 12px !important;
    flex: none;
    order: 0;
    flex-grow: 0;
    //margin: 24px 0px;
  }
  .btn-create {
    font-family: "Ubuntu" !important;
    font-style: normal !important;
    font-size: 16px !important;
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    padding: 4px !important;
    background: #5d5fef !important;
    border-radius: 4px !important;
    margin-top: 24px !important;
    margin-bottom: 4px !important;
    width: auto !important;

    .btn-secondary {
      background-color: transparent;
      border: none;
      color: white;
      padding: 0px;
      margin: 0px;
      font-size: 16px;
    }
    .dropdown-menu {
      font-size: 16px;
      li {
        padding: 0px 0;
        a {
          height: 48px;
        }
      }
      li:hover {
        background: #5d5fef;
        border-radius: 8px;
      }
    }
  }

  .btn-create:hover {
    background: #7a7cff;
  }

  .btn-create:active {
    background: #1719da;
  }
  select.custom-select {
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;
  }
  .table-views {
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 8px;
    padding: 0;
    margin: 30px 5px;
    .t-head {
      background-color: #f5f5f5;
      padding: 5px 15px;
      text-align: left;
    }
    input {
      padding: 10px 10px;
      font-size: 15px;
      height: 50px;
      border-radius: 10px;
    }
    thead tr {
      background-color: #eef2fa;
      border-radius: 10px;
      text-align: left;
    }
    .theading {
      padding: 15px 15px;
    }
    tbody tr {
      border-radius: 10px;
    }
    tbody tr td {
      padding: 15px 15px;
      cursor: pointer;
    }
    tbody tr:hover {
      background-color: #f5f5f5;
    }
  }
}
.modal-content .modal-vp2 {
  #loader2 {
    margin: 40px auto;
    z-index: 1;
    width: 100px;
    height: 100px;
    border: 15px solid #f3f3f3;
    border-radius: 50%;
    border-top: 15px solid #8f8f8f;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }
  .file-upload-img {
    height: 300px;
    border-radius: 25px;
    text-align: center;
    display: flex;
    align-items: center;
    border: 2px gray dashed;
    margin-bottom: 15px;

    input[type="file"] {
      opacity: 0;
      filter: alpha(opacity=0);
      display: block;
      position: absolute;
      cursor: pointer;
      z-index: 1;
      height: 150px;
    }

    span p {
      height: 150px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>